/**
 * ChatSearchBar Component
 * Barra di ricerca per filtrare le chat
 */

import { Search, X, Loader2 } from 'lucide-react';
import { tip } from '@/components/messages/ChatTooltip';

interface ChatSearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  /** Ricerca completa (tutte le chat e i Lead/Clienti) in corso. */
  loading?: boolean;
}

export function ChatSearchBar({
  value,
  onChange,
  placeholder = 'Cerca chat...',
  loading = false,
}: ChatSearchBarProps) {
  return (
    <div className="relative">
      {loading ? (
        <Loader2 className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#2383E2] animate-spin" aria-label="Ricerca in corso" />
      ) : (
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#787774]" />
      )}
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="
          w-full h-9 pl-9 pr-8
          bg-white dark:bg-white/5
          border border-[rgba(55,53,47,0.16)] dark:border-white/10
          rounded-md
          text-sm text-[#37352F] dark:text-white
          placeholder:text-[#787774]
          focus:outline-none focus:border-[#2383E2] focus:ring-2 focus:ring-[#2383E2]/20
          transition-colors
        "
      />
      {value && (
        <button
          onClick={() => onChange('')}
          aria-label="Cancella ricerca"
          {...tip('Cancella ricerca')}
          className="absolute right-2 top-1/2 -translate-y-1/2 p-1 hover:bg-[rgba(55,53,47,0.08)] rounded"
        >
          <X className="w-3.5 h-3.5 text-[#787774]" />
        </button>
      )}
    </div>
  );
}
